import type { AppointmentType } from '@/features/appointments/utils/AppointmentType';
import useAppointmentStore from '@/store/AppointmentStore';

type OrchestrateAppointmentFlow = (type: AppointmentType) => void;

const useOrchestrateAppointmentFlow = (): OrchestrateAppointmentFlow => {
  const setSelectedAppointmentType = useAppointmentStore(
    (s) => s.setSelectedAppointmentType,
  );

  return (type: AppointmentType) => {
    setSelectedAppointmentType(type);
  };
};

export default useOrchestrateAppointmentFlow;
